import { render, staticRenderFns } from "./DocumentPage.vue?vue&type=template&id=45080eb6&"
import script from "./DocumentPage.js?vue&type=script&lang=js&"
export * from "./DocumentPage.js?vue&type=script&lang=js&"
import style0 from "./DocumentPage.scss?vue&type=style&index=0&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports